import { render } from "./PembagianSeragam.vue?vue&type=template&id=37580edf"
import script from "./PembagianSeragam.vue?vue&type=script&lang=js"
export * from "./PembagianSeragam.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__